import React, { Component } from "react";
import { SketchPicker } from "react-color";
import reactCSS from "reactcss";

export default class ThemeSettings extends Component {
  state = {
    displayColorPicker: false,
    color: {
      r: "241",
      g: "112",
      b: "19",
      a: "1"
    }
  };

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false });
  };

  handleChange = color => {
    this.setState({ color: color.rgb });
  };
  render() {
    const styles = reactCSS({
      default: {
        color: {
          width: "36px",
          height: "14px",
          borderRadius: "2px",
          background: `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`
        },
        swatch: {
          padding: "5px",
          background: "#fff",
          borderRadius: "1px",
          boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
          display: "inline-block",
          cursor: "pointer"
        },
        popover: {
          position: "absolute",
          zIndex: "2"
        },
        cover: {
          position: "fixed",
          top: "0px",
          right: "0px",
          bottom: "0px",
          left: "0px"
        }
      }
    });

    return (
      <div>
        <div className="row m-0 mt-3">
          <div className="col-md-6">
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Select Theme
              </label>
              <select class="custom-select col-8">
                <option selected="">Light </option>
                <option value="1">Dark</option>
              </select>
            </div>
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Select Color
              </label>
              <div className="col-8 p-0 d-flex align-items-center">
                <div style={styles.swatch} onClick={this.handleClick}>
                  <div style={styles.color} />
                </div>
                {this.state.displayColorPicker ? (
                  <div style={styles.popover}>
                    <div style={styles.cover} onClick={this.handleClose} />
                    <SketchPicker
                      color={this.state.color}
                      onChange={this.handleChange}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        <div className="p-3 m-0 border-top">
          <div className="btn btn-primary"> Save</div> or{" "}
          <a className="btn-link">Cancel</a>
        </div>
      </div>
    );
  }
}
